import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrIcon from 'client/components/SrIcon';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrModalV2, {
  MODAL_THEME_STACK,
} from 'client/components/SrModalV2/SrModalV2';

class SrWarningOnApprovalApplicationModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onButtonClick: PropTypes.func.isRequired,
  }

  render() {
    const {
      onClose,
      onButtonClick,
    } = this.props;

    return (
      <SrModalV2
        showCloseButton={false}
        contentMaxWidth='384px'
        theme={MODAL_THEME_STACK}
        closeOnBackgroundClick
        onClose={onClose}
      >
        <SrBox margin='60px 34px 40px 34px'>
          <SrFlex direction='col'>
            <SrFlex align='center' direction='col'>
              <SrIcon className='warning-triangle' />
            </SrFlex>
            <SrBox height='26px' />
            <SrText
              font='greycliff'
              weight='800'
              size='26'
              lineHeight='33px'
              align='center'
              width='100%'
              display='block'
            >
              Application is incomplete or not fully qualified.
            </SrText>
            <SrBox height='26px' />
            <SrText
              font='greycliff'
              weight='700'
              size='16'
              lineHeight='33px'
              align='center'
              width='100%'
              display='block'
            >
              Accept this application at your own risk.
            </SrText>
            <SrBox height='8px' />
          </SrFlex>
          <SrBox padding='23px 0 16px'>
            <SrButton
              className='save'
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              onClick={onButtonClick}
              hasBoxShadow
            >
              Approve Application
            </SrButton>
          </SrBox>
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREY}
            onClick={onClose}
          >
            Cancel
          </SrButton>
        </SrBox>
      </SrModalV2>
    );
  }
}

SrWarningOnApprovalApplicationModal.displayName = 'SrWarningOnApprovalApplicationModal';

export default SrWarningOnApprovalApplicationModal;
